import { memo, useEffect } from "react";
import { Table, TableProps } from "antd";
import { useTranslation } from "react-i18next";
import { mdlReservationExtraService } from "../../models/domain/ReservationExtraService";

export type ExtraServiceTable = {
    extraServices?: mdlReservationExtraService[];
}

export const ExtraServiceTable = memo(function ExtraServiceTable(props: ExtraServiceTable) {
    const { t } = useTranslation();

    useEffect(() => {
    }, [props]);

    const columns: TableProps<mdlReservationExtraService>['columns'] = [
        {
            title: t("extraService.code"),
            dataIndex: 'code',
            key: 'code'
        },
        {
            title: t("extraService.definition"),
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: t("extraService.price"),
            key: 'price',
            render: (e: mdlReservationExtraService) => {
                return `${e.price} ${e.currency}`;
            }
        },
    ];

    return (
        <>
            {
                props.extraServices
                &&
                <Table<mdlReservationExtraService>
                    size="small"
                    columns={columns}
                    dataSource={props.extraServices.map((extraService: mdlReservationExtraService, index: number) => ({ ...extraService, key: index }))}
                    pagination={false}
                />
            }
        </>
    )
})